export function getGraphQlEndpoint(): string {
    const win = window as any;
    const base: string = (win.ApiService?.baseUrl as string);
    // ensure trailing slash
    const root = base.endsWith('/') ? base : base + '/';
    return root + 'graphql/';
}

